import React from "react";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";

const PaperPage = () => {
  return (
    <div style={styles.container}>
      <h2 style={styles.heading}>About the Traveling Salesman Problem</h2>
      <div style={styles.pdfContainer}>
      <Worker workerUrl={`https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js`}>
        <Viewer fileUrl="/paper.pdf" />
        </Worker>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: "0px",
    background: "rgb(19, 30, 37)",
    color: "white",
    overflowY: "hidden",
    overflowX: "hidden",
    marginBottom: "20px", 
  },
  heading: {
    marginTop: "3em",
    marginBottom: "20px",
    textAlign: "center",
    
  },
  text: {
    fontSize: "16px",
    marginBottom: "20px",
    textAlign: "center",
  },
  pdfContainer: {
    width: "95%",
    height: "90%",
    border: "1px solid #ccc",
    marginBottom: "20px",
  },
};

export default PaperPage;
